import { render, staticRenderFns } from "./lb-table.vue?vue&type=template&id=69858008&scoped=true"
import script from "./lb-table.vue?vue&type=script&lang=js"
export * from "./lb-table.vue?vue&type=script&lang=js"
import style0 from "./lb-table.vue?vue&type=style&index=0&id=69858008&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69858008",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69858008')) {
      api.createRecord('69858008', component.options)
    } else {
      api.reload('69858008', component.options)
    }
    module.hot.accept("./lb-table.vue?vue&type=template&id=69858008&scoped=true", function () {
      api.rerender('69858008', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/orderBox/saleOrder/components/lb-table/lb-table.vue"
export default component.exports